export function toPercentString(percent: number, fractionDigits = 0) {
  return (percent * 100).toFixed(fractionDigits) + "%"
}
